const base = '/broadcasts';

export const broadcastRoutes = {
  base,
  create: `${base}/create`,
  broadcastId: (id: string) => `${base}/${id}` as const,
  notFound: `${base}/broadcast-not-found`,
} as const;
